
import React, { FC } from "react";

interface CanvasProps {
    svgRef: any;
    gGridRef: any;
    gLinesRef: any;
    gFixedRoomsRef?: any;
    gDimensionsRef: any;
    gPointsRef: any;
    gDeleteButtonsRef?: any;
    drawing: boolean;
    deleteWallMode: boolean;
    fixedRoomMode?: boolean;
}

export const Canvas: FC<CanvasProps> = ({
    svgRef,
    gGridRef,
    gLinesRef,
    gFixedRoomsRef,
    gDimensionsRef,
    gPointsRef,
    gDeleteButtonsRef,
    drawing,
    deleteWallMode,
    fixedRoomMode = false,
}) => {
    return (
        <svg
            ref={svgRef}
            width="100%"
            height="100%"
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "#E8F0F5",
                cursor: deleteWallMode ? "default" : (drawing || fixedRoomMode) ? "crosshair" : "grab",
                userSelect: "none",
                touchAction: "none",
            }}
        >
            <g ref={gGridRef}></g>
            <g ref={gLinesRef}></g>
            <g ref={gFixedRoomsRef}></g>
            <g ref={gDimensionsRef}></g>
            <g ref={gPointsRef}></g>
            <g ref={gDeleteButtonsRef}></g>
        </svg>
    );
};
